import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueGtag from "vue-gtag-next";

// アプリのエントリーポイント
// - router: ページ遷移とハッシュスクロールを担当
// - VueGtag: Google Analytics（必要ない場合はプラグインごと外せます）
const app = createApp(App);

app.use(
  VueGtag,
  {
    property: {
      // 測定ID（GA4）
      id: "G-5V9V548QC3",
    },
  },
  router
);

// ルーティングを有効化
app.use(router);

// DOMへマウント
app.mount("#app");
